import { Select } from 'antd';
import React from 'react';


function UnitAddonAfter({ unit, changeUnit, defaultUnit, list, className, popupClassName = "", style, disabled, id, getPopupContainer }) {
  return <Select
    value={unit || undefined}
    id={id}
    onChange={(key) => changeUnit(key)}
    className={`aurora-select ${className}`}
    popupClassName={`aurora-select-dropdown ${popupClassName}`}
    popupMatchSelectWidth={false}
    style={style}
    disabled={disabled}
    defaultValue={defaultUnit || undefined}
    getPopupContainer={() => getPopupContainer || document.body}
    options={list.map(item => (
      typeof (item) === "string"
        ? { value: item, label: item }
        : { value: item.key, label: item.title })
    )}
  />
}

export default UnitAddonAfter;